import { EnterpriseLicense, UpdateLicenseRequest } from "src/app/predictor-enterprise-license/shared/interface/Enterprise-License";


export namespace EnterpriseLicenseActions {

  export class UpdateLicense {
    static readonly type = '[EnterpriseLicense] Update License';
    constructor(
      public id: string,
      public license: UpdateLicenseRequest,
      public toastMessages?: { success?: string; error?: string } // ✅ add this
    ) {}
  }

  export class CreateLicense {
    static readonly type = '[EnterpriseLicense] Create License';
    constructor(
      public license: EnterpriseLicense,
      public toastMessages?: { success?: string; error?: string } // ✅ add this
    ) {}
  }

  export class DeleteLicense {
    static readonly type = '[EnterpriseLicense] Delete License';
    constructor(
      public id: string,
      public toastMessages?: { success?: string; error?: string } // ✅ add this
    ) {}
  }

   export class GetLicenses {
    static readonly type = '[EnterpriseLicense] Get Licenses';    
  }

   export class ChangePageIndex {
    static readonly type = '[EnterpriseLicense] Change Page Index';
    constructor(public pageIndex: number) {}
  }

  export class ChangePageSize {
    static readonly type = '[EnterpriseLicense] Change Page Size';
    constructor(public pageSize: number) {}
  }

  export class CheckUniqueStudyAreaName {
  static readonly type = '[EnterpriseLicense] Check Unique Study Area Name';
  constructor(
    public studyAreaName: string,
    public licenseNumber: string
  ) {}
}

export class GetLicenseTiers {
    static readonly type = '[EnterpriseLicense] Get License Tiers';
  }
}
